export const customBadWords = [
  "maari tatoori ne chalay",
  "ride my dick",
  "akbaruddin owaisi",
  "biggest cunt",
  "akkal no othmir",
  "less intellect person",
  "alloo bhosri chaat",
  "lick my potato pussy",
  "anuj",
  "biggest choot",
  "babhuchak",
  "idiot",
  "bai no bhosdo",
  "wifes vagina",
  "bapu",
  "very cheap and dirty prostitute",
  "bein chod",
  "sister fuck",
  "benchod",
  "sister fucker",
  "bhadvo",
  "pimp",
  "bhenchod",
  "bhoot",
  "ghost",
  "bhopa",
  "bhos marina",
  "follower of a pussy",
  "bhosad pappu",
  "pussy faggot",
  "bhosdo",
  "piki",
  "pussy",
  "bhosrini",
  "bitch face",
  "bobla",
  "boobs",
  "bobla vagarni baydi",
  "wife without breasts",
  "bosrichord",
  "pussy fuck/fucker",
  "bosrina",
  "bitch",
  "buckwass",
  "bullshit",
  "budhalal",
  "chablo",
  "ass licker",
  "chafu gaan",
  "dirty asshole",
  "chal kotha par",
  "let's go to brothel",
  "chichi",
  "poo poo",
  "chod",
  "chod ami",
  "i fucked your mum last night",
  "chodhru",
  "fucker",
  "chodkanya",
  "sex maniac",
  "chodu",
  "chodu bhagat",
  "horny monk",
  "choidi",
  "rand",
  "fucking prostitute",
  "choot marina",
  "pussy fucker",
  "chupri lauri",
  "shut up dick",
  "chutiya",
  "dheela lund ni olaad",
  "product of a loose penis",
  "divya",
  "black dick eater",
  "eapen",
  "dickhead",
  "fattu",
  "afraid",
  "gaan tari",
  "your arse",
  "gaand ghapli",
  "work getting complicated by someone",
  "gaand ma ghal",
  "stick it in your ass",
  "gaandina",
  "gand ma ghali de",
  "gand maraav",
  "gand nu kaanu",
  "ass hole",
  "gandi chodina",
  "mad fucker",
  "gandi gaan",
  "gando",
  "gando salo",
  "gel ghagharina",
  "lover of skirt",
  "ghant",
  "maniac",
  "ghel chodyo",
  "ghel sappo",
  "ghelchoydi",
  "moron (girl)",
  "halki raand na",
  "son of a cheap prostitute",
  "harsh dalal",
  "pregnant male prostitute",
  "harshit",
  "stuped dumb fuk",
  "hopa",
  "huzefa",
  "moody asshole",
  "ibrahim",
  "white pussy freak",
  "jaaro",
  "humongously obese",
  "jhaanth",
  "pubic hair",
  "jhadhino",
  "jignesh mevani",
  "sc cunt",
  "kajit dhingra",
  "motherfucking loser",
  "karo loro",
  "black cock",
  "kem chho",
  "how are you",
  "kutari",
  "bitch",
  "lakhota",
  "penis balls",
  "land",
  "penis",
  "loda",
  "dick",
  "lodde mari",
  "on my dick",
  "lowroh",
  "balls",
  "cock",
  "lukkha loda",
  "miser dick",
  "luli",
  "lund bhagat",
  "follower of penis",
  "lund choos",
  "suck cock",
  "maa chodi",
  "mother fucker",
  "maa faadi",
  "mother tear",
  "maa ne ghat bhosdina",
  "son of a prostitute/whore",
  "maajaddha",
  "maari tatoori ooper bess",
  "sit on my cock",
  "maasi chodamno",
  "aunty fucker",
  "madachod",
  "mandi susee",
  "small willy",
  "manik",
  "dickhead",
  "mara man no lado",
  "my fucking wish",
  "mari bhosri chaat",
  "lick my pussy",
  "me tamari dagree ma me lakri muki de wano che",
  "i will shove a stick up your ass",
  "meri gaan chatt",
  "lick my ass",
  "mohit",
  "a gay dude",
  "mota jijah",
  "big tits",
  "moti gaand",
  "big ass",
  "nago choido",
  "nakhodiya",
  "impotent",
  "namuno",
  "idiot",
  "narender modi",
  "dick faced",
  "pikina",
  "son of a bitch",
  "pim pim",
  "little fart",
  "poom poom",
  "big fart",
  "priyanshu",
  "small dick",
  "puchi chod",
  "puti",
  "pussy",
  "raand",
  "prostitute",
  "randiyo no raja",
  "prostitute king",
  "rumana umers",
  "sali fukin bitch",
  "salu gutti",
  "you dog",
  "sandas",
  "shit",
  "suwwar jewu",
  "dachu face like a hog",
  "taari bai no aghano",
  "your wife's ass",
  "taari gaand ma dando ghalu",
  "i will stick up a rod in your ass",
  "taari ma parasevo tya-reh e tuti kareh che",
  "your mom sweats when she shits",
  "tara baap ni gaan",
  "your fathers ass",
  "taree gaar ma lowroh",
  "you got a dick up ass",
  "taree ghaar ma doh ladah",
  "you have two shits up your ass",
  "tari bosri kaapi karwa",
  "i will cut your vagina",
  "tari dagri",
  "your arse",
  "tari gaand mare karya kutra balada",
  "pussy faggot",
  "tari gandayli kari koyli dagri",
  "your smelly black rotten arse",
  "tari ma by togo",
  "your moms toes",
  "tari ma na bubla sukai-gya",
  "your mums tits have dried out",
  "tari ma ne hadi kadhto hathi chode",
  "a running elephant fucks your mom",
  "tari ma ni putti",
  "your mother's vagiana",
  "tari ma no bhosdo chatu",
  "i'll lick your mother's pussy",
  "tari ma no poplo",
  "your mothers dick",
  "tari ma nu togo",
  "tari maa na babla chusu",
  "let me lick your mother's boobs",
  "tari maa na bhosda ma maro lodo",
  "my penis in your mom's pussy",
  "tari maa na modha ma maro lodo",
  "my penis in your mom's mouth",
  "tari maa na pika",
  "the bottom part of ur mom",
  "tari maa ne chodu",
  "will fuck you mother",
  "tari maa ni taturi",
  "yours mums dick",
  "tari mai ni gand",
  "your mother's ass",
  "tari mani choot ma derka bole",
  "frog barking in ur mom pussy",
  "tari mano piko",
  "your mum's pussy",
  "taro baap tane chadeche",
  "your dad fucks you",
  "tere ma nu hinta kar",
  "get your mums fanni hair off",
  "teree maah gaderi",
  "your mum is a donkey",
  "thari ma ne bozro maro loro nakhides",
  "ill stick my penis up your mum",
  "thari ma ni ghaan",
  "your mums ass",
  "tooki buddhi",
  "short brained maniac",
  "tusat",
  "sheep shagger",
  "tutelli nirodh no aulad",
  "son of a broken condom",
  "vaandho",
  "unmarried old man",
  "vaishni",
  "silly whore",
  "vevlina ama guj ni array banavi ne apo"
]
